import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import TrustTicker from "../components/TrustTicker";
import HowItWorks from "../components/HowItWorks";
import Benefits from "../components/Benefits";
import DetailedForm from "../components/DetailedForm";
import Testimonials from "../components/Testimonials";
import FAQ from "../components/FAQ";
import FinalCTA from "../components/FinalCTA";
import Footer from "../components/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-[var(--c4p-ivory)]">
      <Navbar />
      <Hero />
      <TrustTicker />
      <HowItWorks />
      <Benefits />
      <DetailedForm />
      <Testimonials />
      <FAQ />
      <FinalCTA />
      <Footer />
    </div>
  );
}
